import { css } from "@emotion/react";

import { SearchBar } from "components/search/SearchBar";
import { TopNav } from "components/shared/layout/TopNav";
import { Authenticated } from "components/shared/library/Authenticated";

import { ExploreJobsSection } from "./ExploreJobsSection";
import { JobsCXWidget } from "./JobsCXWidget";
import { JobsYouMightLike } from "./JobsYouMightLike";
import { RecentJobSearches } from "./RecentJobSearches";

const style = {
  container: css({
    padding: 16,
    display: "flex",
    flexDirection: "column",
    width: "-webkit-fill-available",
    gap: 16,
  }),
};

export const JobsHome = () => {
  return (
    <TopNav
      pageTitle="Jobs"
      customTopNav={
        <SearchBar isFullWidth searchFilter="Jobs" showSearchIcon />
      }
    >
      <div css={style.container}>
        <Authenticated>
          <JobsCXWidget />
        </Authenticated>
        <ExploreJobsSection />
        <JobsYouMightLike />
        <RecentJobSearches />
      </div>
    </TopNav>
  );
};
